// import axios from 'axios';
// import { logoutUser, refreshToken } from './authservices';
// import { config } from '../config/config';
// import toast from 'react-hot-toast';

// export let BASE_URL = config.apiBaseUrl;
// export let CLOUDINARY_URL = config.cloudinaryUrl;
// export let CLOUDINARY_UPLOAD_PRESET = config.cloudinaryUploadPreset;

// const pathName = () => typeof window !== 'undefined' && window;

// export const getToken = async () => {
//     const token = pathName() && localStorage.getItem('token');
//     return token ? JSON.parse(token) : null;
// };

// let isRefreshing = false;
// let failedQueue = [];

// const processQueue = (error, token = null) => {
//     failedQueue.forEach((prom) => {
//         if (error) {
//             prom.reject(error);
//         } else {
//             prom.resolve(token);
//         }
//     });
//     failedQueue = [];
// };

// const apiResource = (customBaseURL = null, customHeaders = null) => {
//     const baseURL = customBaseURL || BASE_URL;

//     const service = axios.create({
//         baseURL: `${baseURL}`,
//         headers: customHeaders
//             ? customHeaders
//             : {
//                   'Access-Control-Allow-Origin': '*',
//                   'Content-Type': 'application/json',
//               },
//     });

//     service.interceptors.request.use(async (req) => {
//         if (!customHeaders) {
//             const token = await getToken();
//             if (token) {
//                 req.headers['Authorization'] = `Bearer ${token}`;
//             }
//         }
//         return req;
//     });

//     service.interceptors.response.use(
//         (res) => res?.data,
//         async (error) => {
//             const originalRequest = error.config;

//             if (
//                 (error?.response?.status === 401 || error?.response?.status === 403) &&
//                 !originalRequest._retry
//             ) {
//                 if (isRefreshing) {
//                     return new Promise((resolve, reject) => {
//                         failedQueue.push({ resolve, reject });
//                     })
//                         .then((token) => {
//                             originalRequest.headers['Authorization'] = `Bearer ${token}`;
//                             return service(originalRequest);
//                         })
//                         .catch((err) => Promise.reject(err));
//                 }

//                 originalRequest._retry = true;
//                 isRefreshing = true;

//                 try {
//                     const newToken = await refreshToken();
//                     if (newToken) {
//                         service.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
//                         processQueue(null, newToken);
//                         return service(originalRequest);
//                     } else {
//                         processQueue('Session expired', null);
//                         toast.error('Session expired. Please log in again.', {
//                             position: 'top-right',
//                         });
//                         return Promise.reject(error);
//                     }
//                 } catch (refreshError) {
//                     processQueue(refreshError, null);
//                     toast.error('Session expired. Please log in again.', { position: 'top-right' });
//                     logoutUser();
//                     return Promise.reject(refreshError);
//                 } finally {
//                     isRefreshing = false;
//                 }
//             }

//             if (error?.code === 'ERR_NETWORK') {
//                 toast.error('Something went wrong, please try again later', {
//                     position: 'top-right',
//                 });
//                 return Promise.reject('Something went wrong, please try again later');
//             }

//             // const status = error?.response?.status;
//             const errors = error?.response?.data;
//             const errorMessage = errors?.error || errors?.message;

//             if (errorMessage) {
//                 // Optionally show toast
//                 // toast.error(errorMessage);
//             }

//             return Promise.reject(errors);
//         },
//     );

//     return {
//         setConfig: (newCustomBaseURL = null, newCustomHeaders = null) => {
//             return apiResource(newCustomBaseURL, newCustomHeaders);
//         },
//         service,
//         get: async (url) => {
//             try {
//                 const data = await service.get(url);
//                 return data;
//             } catch (error) {
//                 return Promise.reject(error);
//             }
//         },
//         post: async ({ url, payload }) => {
//             try {
//                 const data = await service.post(url, payload);
//                 return data;
//             } catch (error) {
//                 return Promise.reject(error);
//             }
//         },
//         patch: async ({ url, payload }) => {
//             try {
//                 const data = await service.patch(url, payload);
//                 return data;
//             } catch (error) {
//                 return Promise.reject(error);
//             }
//         },
//         delete: async ({ url, payload }) => {
//             try {
//                 const data = await service.delete(url, payload);
//                 return data;
//             } catch (error) {
//                 return Promise.reject(error);
//             }
//         },
//         put: async ({ url, payload }) => {
//             try {
//                 const data = await service.put(url, payload);
//                 return data;
//             } catch (error) {
//                 return Promise.reject(error);
//             }
//         },
//     };
// };

// export const apiService = apiResource();
// export const unAuthenticatedApiService = apiResource(null, {});
// export const externalApiService = apiResource(config.externalBaseUrl, {});
// export const shopApiService = apiResource(config.shopBaseUrl, {});

import axios from 'axios';
import { logoutUser, refreshToken } from './authservices';
import { config } from '../config/config';
import toast from 'react-hot-toast';

export let BASE_URL = config.apiBaseUrl;
export let CLOUDINARY_URL = config.cloudinaryUrl;
export let CLOUDINARY_UPLOAD_PRESET = config.cloudinaryUploadPreset;

const pathName = () => typeof window !== 'undefined' && window;

export const getToken = async () => {
    const token = pathName() && localStorage.getItem('token');
    return token ? JSON.parse(token) : null;
};

/* ─────────────────────────────────────────────────────────────
   ROUTE HELPERS
   ───────────────────────────────────────────────────────────── */

/**
 * True when the user is currently viewing an auth page where a
 * "Session expired" toast would be redundant or confusing.
 *
 * The login page in particular fires `logoutUser` defensively on
 * mount, which can trip the 401 path here. We don't want to scream
 * "Session expired" at someone who's literally looking at a login
 * form — they already know they aren't signed in.
 */
const isOnAuthRoute = () => {
    if (typeof window === 'undefined') return false;
    const path = window.location.pathname || '';
    return (
        path === '/login' ||
        path.startsWith('/login/') ||
        path === '/register' ||
        path.startsWith('/register/') ||
        path === '/forgot-password' ||
        path.startsWith('/forgot-password/') ||
        path.startsWith('/reset-password')
    );
};

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

const apiResource = (customBaseURL = null, customHeaders = null) => {
    const baseURL = customBaseURL || BASE_URL;

    const service = axios.create({
        baseURL: `${baseURL}`,
        headers: customHeaders
            ? customHeaders
            : {
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json',
              },
    });

    service.interceptors.request.use(async (req) => {
        if (!customHeaders) {
            const token = await getToken();
            if (token) {
                req.headers['Authorization'] = `Bearer ${token}`;
            }
        }
        return req;
    });

    service.interceptors.response.use(
        (res) => res?.data,
        async (error) => {
            const originalRequest = error.config;

            if (
                (error?.response?.status === 401 || error?.response?.status === 403) &&
                !originalRequest._retry
            ) {
                if (isRefreshing) {
                    return new Promise((resolve, reject) => {
                        failedQueue.push({ resolve, reject });
                    })
                        .then((token) => {
                            originalRequest.headers['Authorization'] = `Bearer ${token}`;
                            return service(originalRequest);
                        })
                        .catch((err) => Promise.reject(err));
                }

                originalRequest._retry = true;
                isRefreshing = true;

                try {
                    const newToken = await refreshToken();
                    if (newToken) {
                        service.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                        processQueue(null, newToken);
                        return service(originalRequest);
                    } else {
                        processQueue('Session expired', null);
                        /* Suppress on auth pages — user is already where
                           they need to be, no need to scream at them. */
                        if (!isOnAuthRoute()) {
                            toast.error('Session expired. Please log in again.', {
                                position: 'top-right',
                            });
                        }
                        return Promise.reject(error);
                    }
                } catch (refreshError) {
                    processQueue(refreshError, null);
                    if (!isOnAuthRoute()) {
                        toast.error('Session expired. Please log in again.', {
                            position: 'top-right',
                        });
                    }
                    logoutUser();
                    return Promise.reject(refreshError);
                } finally {
                    isRefreshing = false;
                }
            }

            if (error?.code === 'ERR_NETWORK') {
                /* Network errors during login should also stay inline
                   so we don't double-notify. Suppress on auth pages. */
                if (!isOnAuthRoute()) {
                    toast.error('Something went wrong, please try again later', {
                        position: 'top-right',
                    });
                }
                return Promise.reject('Something went wrong, please try again later');
            }

            // const status = error?.response?.status;
            const errors = error?.response?.data;
            const errorMessage = errors?.error || errors?.message;

            if (errorMessage) {
                // Optionally show toast
                // toast.error(errorMessage);
            }

            return Promise.reject(errors);
        },
    );

    return {
        setConfig: (newCustomBaseURL = null, newCustomHeaders = null) => {
            return apiResource(newCustomBaseURL, newCustomHeaders);
        },
        service,
        get: async (url) => {
            try {
                const data = await service.get(url);
                return data;
            } catch (error) {
                return Promise.reject(error);
            }
        },
        post: async ({ url, payload }) => {
            try {
                const data = await service.post(url, payload);
                return data;
            } catch (error) {
                return Promise.reject(error);
            }
        },
        patch: async ({ url, payload }) => {
            try {
                const data = await service.patch(url, payload);
                return data;
            } catch (error) {
                return Promise.reject(error);
            }
        },
        delete: async ({ url, payload }) => {
            try {
                const data = await service.delete(url, payload);
                return data;
            } catch (error) {
                return Promise.reject(error);
            }
        },
        put: async ({ url, payload }) => {
            try {
                const data = await service.put(url, payload);
                return data;
            } catch (error) {
                return Promise.reject(error);
            }
        },
    };
};

export const apiService = apiResource();
export const unAuthenticatedApiService = apiResource(null, {});
export const externalApiService = apiResource(config.externalBaseUrl, {});
export const shopApiService = apiResource(config.shopBaseUrl, {});